const translations = {
  "en": {
    "Select a Theme": "Select a Theme"
  },
  "zh-tw": {
    "Select a Theme": "選擇一個主題"
  }
};

export default translations;
